module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch2.jpg",
      "width": "8%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("We stood and stared as the wolf-crab crawled toward us.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please sit down, kids,” a voice called out behind us. “I can’t see the screen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ssshhhh!” someone else whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marty and I glanced at each other. I guess we both felt like jerks. I know I did. We dropped back into our seats.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And watched the wolf-crab scamper across the street, chasing after a little boy on a tricycle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s your problem, Erin?” Marty whispered, shaking his head. “It’s only a movie. Why did you scream like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You screamed, too!” I replied sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I only screamed because you screamed!” he insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sssshhh!” someone pleaded. I sank low in the seat. I heard crunching sounds all around me. People eating popcorn. Someone behind me coughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the screen, the wolf-crab reached out his big, red claws and grabbed the kid on the trike. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SNAP. SNAP.")]), _vm._v(" Good-bye, kid.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some people in the theater laughed. It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" pretty funny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s the great thing about the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shocker on Shock Street")]), _vm._v(" movies. They make you scream and laugh at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marty and I sat back and enjoyed the rest of the movie. We love scary movies, but the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shock Street")]), _vm._v(" films are our favorites.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the end, the police caught the wolf-crab. They boiled him in a big pot of water. Then they served steamed crab to the whole town. Everyone sat around dipping him in butter sauce. They all said he was delicious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was the perfect ending. Marty and I clapped and cheered. Marty put two fingers in his mouth and whistled through his teeth the way he always does.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We had just seen "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shocker on Shock Street VI")]), _vm._v(", and it was definitely the best one of the series.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The theater lights came on. We turned up the aisle and started to make our way through the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great special effects,” a man told his friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Special effects?” the friend replied. “I thought it was all real!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They both laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marty bumped me hard from behind. He thinks it’s funny to try and knock me over. “Pretty good movie,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I turned back to him. “Huh? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pretty")]), _vm._v(" good?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, it wasn’t scary enough,” he replied. “Actually, it was kind of babyish. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shocker V")]), _vm._v(" was a lot scarier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I rolled my eyes. “Marty, you screamed your head off — remember? You jumped out of your seat. You grabbed my arm and —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I only did that because I saw how scared you were,” he said, grinning. What a liar! Why can’t he ever admit it when he’s scared?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stuck his sneaker out and tried to trip me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I dodged to the left, stumbled — and bumped hard into a young woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey — look out!” she cried. “You twins should be more careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re not twins!” Marty and I cried in unison.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We’re not even brother and sister. We’re not related in any way. But people always think that Marty and I are twins.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I guess we do look a lot alike. We’re both twelve years old. And we’re both pretty short and kind of chubby. We both have round faces, short black hair, and blue eyes. And we both have little noses that sort of turn up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But we’re not twins! We’re only friends.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I apologized to the woman. When I turned back to Marty, he stuck out his shoe and tried to trip me again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I stumbled, but quickly caught my balance. Then I stuck out my shoe — and tripped him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We kept tripping each other through the long lobby. People were staring at us, but we didn’t care. We were laughing too hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you know the coolest thing about this movie?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That we’re the first kids in the world to see it!” I exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah!” Marty and I slapped each other a high five.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We had just seen "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shocker on Shock Street VI")]), _vm._v(" at a special sneak preview. My dad works with a lot of movie people, and he got us tickets for it. The others in the theater were all adults. Marty and I were the only kids.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Know what else was really cool?” I asked. “The monsters. All of them. They looked so incredibly real. It didn’t look like special effects at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marty frowned. “Well, I thought the Electric Eel Woman was pretty phony-looking. She didn’t look like an eel — she looked like a big worm!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I laughed. “Then why did you jump out of your seat when she shot a bolt of electricity and fried that gang of teenagers?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t jump,” Marty insisted. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You")]), _vm._v(" did!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did not! You jumped because it looked so real,” I insisted. “And I heard you choke when the Toxic Creep leaped out of the nuclear waste pit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I choked on a Milk Dud, that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were scared, Marty, because it was so real.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey — what if they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" real?!” Marty exclaimed. “What if it isn’t special effects? What if they’re all "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("real monsters")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t be dumb,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We turned the corner into another hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The wolf-crab stood waiting for me there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t even have time to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He opened his toothy jaws in a long wolf howl — and wrapped two giant red claws around my waist.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52408d77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545820585_ch002.vue
// module id = 66
// module chunks = 0